import { useState } from 'react';
import { GoogleLogin } from '@react-oauth/google';
// @mui
import { Stack, Divider, Typography, Alert } from '@mui/material';
// hooks
import useAuth from '../../hooks/useAuth';

// ----------------------------------------------------------------------

export default function AuthSocialLogin() {
  const { loginWithGoogle } = useAuth();
  const [error, setError] = useState(null);

  const handleGoogleSuccess = async (credentialResponse) => {
    try {
      setError(null);
      await loginWithGoogle(credentialResponse.credential);
    } catch (e) {
      setError('Error al iniciar sesion con Google');
    }
  };

  const handleGoogleError = () => {
    setError('Error al conectar con Google');
  };

  return (
    <>
      {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
      <Stack direction="row" justifyContent="center" sx={{ mb: 1 }}>
        <GoogleLogin
          onSuccess={handleGoogleSuccess}
          onError={handleGoogleError}
          size="large"
          width="100%"
          text="continue_with"
          shape="rectangular"
        />
      </Stack>
      <Divider sx={{ my: 3 }}>
        <Typography variant="body2" sx={{ color: 'text.secondary' }}>
          O
        </Typography>
      </Divider>
    </>
  );
}
